const firebase = require("firebase/app");
require("firebase/auth");
require("firebase/database");
require("firebase/firestore");

export const getUser = async uid => {
  return new Promise((resolve, reject) => {
    firebase
      .firestore()
      .collection("users")
      .doc(uid)
      .get()
      .then(doc => {
        if (doc.exists) {
          resolve(doc.data());
        } else {
          reject(uid);
        }
      })
      .catch(err => reject(err));
  });
};

export const logIn = async (email, password) => {
  return new Promise((resolve, reject) => {
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(r => resolve(r))
      .catch(error => reject(error));
  });
};

export const logOut = async () => {
  return new Promise((resolve, reject) => {
    firebase
      .auth()
      .signOut()
      .then(res => resolve(res))
      .catch(error => reject(error));
  });
};

export const inscription = async form => {
  return new Promise((resolve, reject) => {
    firebase
      .auth()
      .createUserWithEmailAndPassword(form.email, form.password)
      .then(r => {
        let uid = r.user.uid;
        firebase
          .firestore()
          .collection("users")
          .doc(uid)
          .set({
            name: form.name,
            firstname: form.firstname,
            email: form.email,
            phone: form.phone,
            civility: form.civility,
            structure: form.structure,
            fonction: form.fonction
          })
          .then(r => {
            resolve(r);
          });
      })
      .catch(error => {
        reject(error);
      });
  });
};
